import { render, staticRenderFns } from "./VMLogEntriesStats.vue?vue&type=template&id=21dcd807&"
import script from "./VMLogEntriesStats.vue?vue&type=script&lang=js&"
export * from "./VMLogEntriesStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports